/**
 * Email body locale strings often hardcode sender initials (e.g. <p>FR</p> in sd4_email_text).
 * Replace those literals with t(from_initials) so translation overrides apply in the body too.
 */
export function applyFromInitialsToEmailHtml(html, fromInitialsKey, t) {
    if (!html || !fromInitialsKey || !t) return html;
    const translated = t(fromInitialsKey);
    if (!translated || !html.includes(fromInitialsKey)) return html;
    return html.split(fromInitialsKey).join(translated);
}
